@if (formatted) {
  <span [class]="size" [class.emphasis]="emphasis">{{ whole }},<span class="superscript">{{ decimals }}</span></span>
} @else {
  <span [class]="size" [class.emphasis]="emphasis">{{ whole }},{{ decimals }}</span>
}
@if (monthly) {
  <span [class]="size" [class.emphasis]="emphasis">/mnd</span>
}
